export enum ReportType {
  None = 0,
  Custom = 1
}
